import { Text } from "@meditect/medibase-components";

import { ErrorMessageComponent } from "@/features/api/domain/ErrorMessageComponent";

// biome-ignore lint/complexity/noBannedTypes: <explanation>
export const StocksCannotDeleteDepackagingSettingBecauseStockItemIsOnOpenInventoryError: ErrorMessageComponent<{}> = () => {
  return (
    <Text as="span" mr={1}>
      Une ligne de stock au détail fait partie d'un inventaire en cours. Validez ou annulez l'inventaire avant de
      supprimer la configuration du déconditionnement.
    </Text>
  );
};
